import { render, staticRenderFns } from "./EbpfPortability.vue?vue&type=template&id=54ff2661&scoped=true"
import script from "./EbpfPortability.vue?vue&type=script&lang=js"
export * from "./EbpfPortability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ff2661",
  null
  
)

export default component.exports